import MobXWrapper from './MobXWrapper';

export default MobXWrapper;
